import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'

import { Card, Form, Select, Button } from 'antd'
import { FileTextTwoTone } from '@ant-design/icons'

import { INVOICE_HEADER_TYPE } from '../../constants/taxInvoices'
import actions from '../../redux/orders/accounting/actions'

const { saveOrderBusinessAddress, setShowInvoiceHeaderTypeForm } = actions

class InvoiceHeaderTypeForm extends Component {
    static propTypes = {
        invoice: PropTypes.object.isRequired,
        orderId: PropTypes.string.isRequired,

        accountings: ImmutablePropTypes.map.isRequired,
        saveOrderBusinessAddress: PropTypes.func.isRequired,
        setShowInvoiceHeaderTypeForm: PropTypes.func.isRequired
    }

    handleSubmit = (params) => {
        const { invoice, orderId, saveOrderBusinessAddress } = this.props

        saveOrderBusinessAddress({
            address: params,
            id: invoice.id,
            orderId,
            onSuccess: () => {
                this.handleToggleForm()
            }
        })
    }

    handleToggleForm = (id = null) => {
        this.props.setShowInvoiceHeaderTypeForm({ id })
    }

    headerTypeOptions = () => {
        const { i18n } = this.props

        return INVOICE_HEADER_TYPE.map((headerType) => (
            <Select.Option key={headerType.value} value={headerType.value}>
                {i18n.t(`confirms:invoice.${headerType.i18n}`)}
            </Select.Option>
        ))
    }

    headerTypeLabel = () => {
        const { i18n, invoice } = this.props
        const value = _.get(invoice, 'invoice_header_type', 'receipt')
        const headerType = INVOICE_HEADER_TYPE.find(
            (option) => option.value === value
        )

        if (!headerType) return value

        return i18n.t(`confirms:invoice.${headerType.i18n}`)
    }

    renderForm () {
        const { i18n, invoice } = this.props

        return (
            <Card size="small" style={{ minWidth: '220px' }}>
                <Form onFinish={this.handleSubmit} layout='vertical'>
                    <Form.Item style={{ margin: '0px' }}
                        label={i18n.t('confirms:invoice.invoiceHeaderType')}
                        name='invoice_header_type'
                        initialValue={_.get(invoice, 'invoice_header_type', 'receipt')}>
                            <Select popupMatchSelectWidth={false}>
                                {this.headerTypeOptions()}
                            </Select>
                    </Form.Item>

                    <div style={{ textAlign: 'center' }}>
                        <Button htmlType="submit" size="small" type="primary">
                            {i18n.t('shared:save')}
                        </Button>
                        <Button
                            onClick={() => this.handleToggleForm()}
                            size="small"
                            style={{ marginLeft: '10px' }}>
                            {i18n.t('shared:close')}
                        </Button>
                    </div>
                </Form>
            </Card>
        )
    }

    render () {
        const { i18n, invoice, accountings } = this.props
        const invoiceId = _.get(invoice, 'id', '')

        if (accountings.get('activeEditInvoiceHeaderType') === invoiceId) {
            return this.renderForm()
        }

        return (
            <a onClick={() => this.handleToggleForm(invoiceId)}>
                <div>
                    <FileTextTwoTone />{' '}
                    {i18n.t('confirms:invoice.invoiceHeaderType')}: {this.headerTypeLabel()}
                </div>
            </a>
        )
    }
}

const mapStateToProps = state => ({
    accountings: state.get('orderPaymentDetails')
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        saveOrderBusinessAddress,
        setShowInvoiceHeaderTypeForm
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withTranslation(['confirms', 'shared'])(InvoiceHeaderTypeForm))
